import { AttachmentFileType } from 'owa-attachment-file-types';
import { ITEM_ID_ATTACHMENT_TYPE } from 'owa-attachment-constants/lib/attachmentTypes';
import type { AttachmentFile } from 'owa-attachment-well-data';

export default function createAttachmentFileFromSonoraSuggestion(suggestion) {
    const attachmentFile: AttachmentFile = {
        fileType: AttachmentFileType.AttachmentItemSuggestion,
        name: suggestion.fileName,
        size: suggestion.fileSize,
        attachmentItemId: suggestion.attachmentId,
        type: ITEM_ID_ATTACHMENT_TYPE,
    };
    return attachmentFile;
}
